import { render } from "./OutilCard.vue?vue&type=template&id=225effd0"
import script from "./OutilCard.vue?vue&type=script&lang=js"
export * from "./OutilCard.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__